import {
    Component,
    EventEmitter,
    Input,
    OnChanges,
    OnDestroy,
    OnInit,
    Output,
    ViewChild
} from '@angular/core';
import { DaterangePickerComponent, DaterangepickerConfig } from 'ng2-daterangepicker';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';
import * as _ from 'lodash';
import {DateRange, DateRangeForReport, DateRangeForFreeTier, DateRangeForFreeTierReport} from '../../shared/enums/date-range.enum';

@Component({
    selector: 'app-daterangepicker',
    templateUrl: 'daterangepicker.component.html',
})
export class DaterangepickerComponent implements OnInit, OnChanges, OnDestroy {
    @Input() isReport = false;
    @Input() newer = false;
    @Input() useMinDate = false;
    @Output() setTimes: EventEmitter<any> = new EventEmitter<any>();

    //ng2-daterangepicker component
    @ViewChild(DaterangePickerComponent)
    private picker: DaterangePickerComponent;

    private _options: any;
    private subscription: any;
    private dateRange: any = {};
    private tmznOfs = '+09:00';

    defaultHistType: String = 'w'; //현재 기준 한 달 전

    calendarParams: any = {
        fromDate:  '',
        fromTime:  '',
        toDate: '',
        toTime: '',
        label: ''
    };
    public currLcnsTypeCd = '';
    constructor(private daterangepickerOptions: DaterangepickerConfig, private translate: TranslateService) {
        this.tmznOfs = global['loginUser'].tmznAplyTypeCd === 'LOGIN_TIMEZONE' ? global['loginUser'].loginTmznOfs : global['loginUser'].prflTmznOfs;
        this.currLcnsTypeCd = global['userRole'].currLcnsTypeCd;

    }


    get options(): any {
        return this._options;
    }

    @Input()
    set options( options: any ) {
        this._options = options;
    }

    ngOnInit() {
        this.daterangepickerOptions.skipCSS = true;
        if (this.useMinDate) {
            this.daterangepickerOptions.settings = {
                startDate: moment().utcOffset(this.tmznOfs).subtract(6, 'days').format('YYYY-MM-DD'),
                endDate: moment().utcOffset(this.tmznOfs),
                minDate: moment().utcOffset(this.tmznOfs).subtract(3, 'month').startOf('day'),
                showDropdowns: false,
                autoUpdateInput: false,
                // linkedCalendars: false, // 우측: 시작날짜, 좌측: 종료날짜 선택하는 것으로 정책 협의함(2019.04.02,안소영,이혜린,장지은)
                buttonClasses: 'middle button',
                applyClass: 'blue',
                cancelClass: 'darkgray',
                locale: { format: 'YYYY-MM-DD', separator: ' ~ ' }
            };
        } else {
            this.daterangepickerOptions.settings = {
                startDate: moment().utcOffset(this.tmznOfs).subtract(6, 'days').format('YYYY-MM-DD'),
                endDate: moment().utcOffset(this.tmznOfs),
                showDropdowns: false,
                autoUpdateInput: false,
                // linkedCalendars: false, // 우측: 시작날짜, 좌측: 종료날짜 선택하는 것으로 정책 협의함(2019.04.02,안소영,이혜린,장지은)
                buttonClasses: 'middle button',
                applyClass: 'blue',
                cancelClass: 'darkgray',
                locale: { format: 'YYYY-MM-DD', separator: ' ~ ' }
            };
        }

        this.subscription = this.translate.onLangChange.subscribe((event: LangChangeEvent) => {
            // this.updateTranslateCalendar();
            // TODO: 임시 땜방 소스 : 언어 변경 시 재호출 되지 않고 스타일 틀어지는 부분 존재함.
            this.dateRange = {};
            const type = this.getType();
            switch (type) {
                case 'free':
                    this.dateRange[this.translate.instant('MK.00892')] = [moment().utcOffset(this.tmznOfs).startOf('day'), moment().utcOffset(this.tmznOfs)]; // 오늘
                    this.dateRange[this.translate.instant('MK.00901')] = [moment().utcOffset(this.tmznOfs).subtract(1, 'days').startOf('day'), moment().utcOffset(this.tmznOfs).subtract(1, 'days').endOf('day')]; // 어제
                    this.dateRange[this.translate.instant('MK.01370')] = [moment().utcOffset(this.tmznOfs).subtract(6, 'days').startOf('day'), moment().utcOffset(this.tmznOfs)];   //최근 일주일
                    break;
                case 'freeReport':
                    this.dateRange[this.translate.instant('MK.01370')] = [moment().utcOffset(this.tmznOfs).subtract(6, 'days').startOf('day'), moment().utcOffset(this.tmznOfs)];   //최근 일주일
                    break;
                case 'standardReport':
                    this.dateRange[this.translate.instant('MK.01370')] = [moment().utcOffset(this.tmznOfs).subtract(6, 'days').startOf('day'), moment().utcOffset(this.tmznOfs)];
                    this.dateRange[this.translate.instant('MK.01473')] = [moment().utcOffset(this.tmznOfs).subtract(1, 'month').startOf('day'), moment().utcOffset(this.tmznOfs)];
                    this.dateRange[this.translate.instant('MK.01474')] = [moment().utcOffset(this.tmznOfs).subtract(3, 'month').startOf('day'), moment().utcOffset(this.tmznOfs)];
                    break;
                case 'standard':
                default:
                    this.dateRange[this.translate.instant('MK.00013')] = [moment('2016-01-01'), moment().utcOffset(this.tmznOfs)];      //전체
                    this.dateRange[this.translate.instant('MK.00892')] = [moment().utcOffset(this.tmznOfs).startOf('day'), moment().utcOffset(this.tmznOfs)]; // 오늘
                    this.dateRange[this.translate.instant('MK.00901')] = [moment().utcOffset(this.tmznOfs).subtract(1, 'days').startOf('day'), moment().utcOffset(this.tmznOfs).subtract(1, 'days').endOf('day')]; // 어제
                    this.dateRange[this.translate.instant('MK.01370')] = [moment().utcOffset(this.tmznOfs).subtract(6, 'days').startOf('day'), moment().utcOffset(this.tmznOfs)];   //최근 일주일
                    this.dateRange[this.translate.instant('MK.01473')] = [moment().utcOffset(this.tmznOfs).subtract(1, 'month').startOf('day'), moment().utcOffset(this.tmznOfs)];   //최근 한달
                    this.dateRange[this.translate.instant('MK.00904')] = [moment().utcOffset(this.tmznOfs).startOf('week'), moment().utcOffset(this.tmznOfs).endOf('week')];
                    this.dateRange[this.translate.instant('MK.00903')] = [moment().utcOffset(this.tmznOfs).startOf('month'), moment().utcOffset(this.tmznOfs).endOf('month')]; // this month
                    this.dateRange[this.translate.instant('MK.00005')] = [moment().utcOffset(this.tmznOfs).subtract(1, 'week').startOf('week'), moment().utcOffset(this.tmznOfs).subtract(1, 'week').endOf('week')];
                    this.dateRange[this.translate.instant('MK.00006')] = [moment().utcOffset(this.tmznOfs).subtract(1, 'month').startOf('month'), moment().utcOffset(this.tmznOfs).subtract(1, 'month').endOf('month')]; // last month
                    break;
            }

            this.options = {
                autoUpdateInput: true,
                ranges: this.dateRange,
                // startDate: rangeObj[0].format('YYYY-MM-DD'),
                // endDate: rangeObj[1].format('YYYY-MM-DD'),
                locale: {
                    format: 'YYYY-MM-DD',
                    cancelLabel: this.translate.instant('MK.00048'),
                    customRangeLabel: this.translate.instant('MK.00905'),
                    applyLabel: this.translate.instant('MK.00049'),
                    daysOfWeek: [
                        this.translate.instant('MK.00868'),
                        this.translate.instant('MK.00869'),
                        this.translate.instant('MK.00870'),
                        this.translate.instant('MK.00871'),
                        this.translate.instant('MK.00872'),
                        this.translate.instant('MK.00873'),
                        this.translate.instant('MK.00874')
                    ],
                    monthNames: [
                        this.translate.instant('MK.00875'),
                        this.translate.instant('MK.00876'),
                        this.translate.instant('MK.00877'),
                        this.translate.instant('MK.00878'),
                        this.translate.instant('MK.00879'),
                        this.translate.instant('MK.00880'),
                        this.translate.instant('MK.00881'),
                        this.translate.instant('MK.00882'),
                        this.translate.instant('MK.00883'),
                        this.translate.instant('MK.00884'),
                        this.translate.instant('MK.00885'),
                        this.translate.instant('MK.00886')
                    ]
                },
                alwaysShowCalendars: false,
                maxDate: moment().utcOffset(this.tmznOfs)
            };
        });
    }

    ngOnChanges() {
        this.tmznOfs = global['loginUser'].tmznAplyTypeCd === 'LOGIN_TIMEZONE' ? global['loginUser'].loginTmznOfs : global['loginUser'].prflTmznOfs;
    }

    // ngAfterViewInit() {
    // }

    ngOnDestroy(): void {
        this.subscription.unsubscribe();
    }

    public selectedDate(value: any) {
        // this is the date the iser selected
        //console.log('invoked selectedDate event:', value);
    }

    // expected output is an object containing the event and the picker.
    // your method can be named whaterver you want.
    // you can add multiple params to the method and pass them in the template
    public calendarCanceled(e: any) {
        // console.log('custom cancel event:', e);
    }

    public calendarApplied(e: any) {
        let RangeIdx;

        this.calendarParams.fromDate = e.picker.startDate.format('YYYY-MM-DD');
        this.calendarParams.fromTime = e.picker.startDate.format('HH:mm');
        this.calendarParams.toDate = e.picker.endDate.format('YYYY-MM-DD');
        this.calendarParams.toTime = e.picker.endDate.format('HH:mm');

        const ranges = _.values(e.picker.ranges);

        RangeIdx =  _.findIndex(ranges, function(o) { return o[0] === e.picker.startDate; });

        if (RangeIdx === -1) {
            const type = this.getType();
            switch (type) {
                case 'free':
                    RangeIdx = DateRangeForFreeTier.CUSTOM;
                    break;
                case 'freeReport':
                    RangeIdx = DateRangeForFreeTierReport.CUSTOM;
                    break;
                case 'standardReport':
                    RangeIdx = DateRangeForReport.CUSTOM;
                    break;
                case 'standard':
                default:
                    RangeIdx = DateRange.CUSTOM;
                    break;
            }
        }

        this.calendarParams.label = RangeIdx;
        this.setTimes.emit(this.calendarParams);
    }

    public sendDateParam() {
        this.setTimes.emit({
            fromDate: moment().utcOffset(this.tmznOfs).subtract(1, 'day').format('YYYY-MM-DD'),
            fromTime: '00:00', //moment().format('HH:mm'),
            toDate: moment().utcOffset(this.tmznOfs).format('YYYY-MM-DD'),
            toTime: '23:59' //moment().format('HH:mm')
        });
    }

    /* Caller에 Date 값 전송 */
    public setDatePickerRange(time: any) {
        let rangeObj: any;
        const ranges = _.values(this.dateRange);


        const type = this.getType();

        if ( (type === 'free' && time.label === DateRangeForFreeTier.CUSTOM)
            || (type === 'freeReport' && time.label === DateRangeForFreeTierReport.CUSTOM)
            || (type === 'standardReport' && time.label === DateRangeForReport.CUSTOM)
            || (type === 'standard' && time.label === DateRange.CUSTOM)) {
            rangeObj = [moment(time.fromDate), moment(time.toDate)];
        } else {
            rangeObj = ranges[time.label];
        }

        this.setTimes.emit({
            fromDate: rangeObj[0].format('YYYY-MM-DD'),
            fromTime: '00:00', //rangeObj[0].format('HH:mm'),
            toDate: rangeObj[1].format('YYYY-MM-DD'),
            toTime: '23:59', //rangeObj[1].format('HH:mm'),
            label : time.label
        });
    }

    focusAdd($evnet) {
        if ($evnet.target.parentElement.classList.contains('opens')) {
            $evnet.target.parentElement.classList.remove('opens');
            // $('.daterangepicker.dropdown-menu.ltr.opensright').css('display', 'none');  // IT04AN-942 이슈로 주석 처리
        } else {
            $evnet.target.parentElement.classList.add('opens');
            // $('.daterangepicker.dropdown-menu.ltr.opensright').css('display', 'inline'); // IT04AN-942 이슈로 주석 처리
        }
    }

    blurAdd($evnet) {
        $evnet.target.parentElement.classList.remove('opens');
    }

    updateTranslateCalendar(times?: any) {
        const type = this.getType();
        switch (type) {
            case 'free':
                this.dateRange[this.translate.instant('MK.00892')] = [moment().utcOffset(this.tmznOfs).startOf('day'), moment().utcOffset(this.tmznOfs)]; // 오늘
                this.dateRange[this.translate.instant('MK.00901')] = [moment().utcOffset(this.tmznOfs).subtract(1, 'days').startOf('day'), moment().utcOffset(this.tmznOfs).subtract(1, 'days').endOf('day')]; // 어제
                this.dateRange[this.translate.instant('MK.01370')] = [moment().utcOffset(this.tmznOfs).subtract(6, 'days').startOf('day'), moment().utcOffset(this.tmznOfs)];   //최근 일주일
                break;
            case 'freeReport':
                this.dateRange[this.translate.instant('MK.01370')] = [moment().utcOffset(this.tmznOfs).subtract(6, 'days').startOf('day'), moment().utcOffset(this.tmznOfs)];   //최근 일주일
                break;
            case 'standardReport':
                this.dateRange[this.translate.instant('MK.01370')] = [moment().utcOffset(this.tmznOfs).subtract(6, 'days').startOf('day'), moment().utcOffset(this.tmznOfs)];
                this.dateRange[this.translate.instant('MK.01473')] = [moment().utcOffset(this.tmznOfs).subtract(1, 'month').startOf('day'), moment().utcOffset(this.tmznOfs)];
                this.dateRange[this.translate.instant('MK.01474')] = [moment().utcOffset(this.tmznOfs).subtract(3, 'month').startOf('day'), moment().utcOffset(this.tmznOfs)];
                break;
            case 'standard':
            default:
                this.dateRange[this.translate.instant('MK.00013')] = [moment('2016-01-01'), moment().utcOffset(this.tmznOfs)];      //전체
                this.dateRange[this.translate.instant('MK.00892')] = [moment().utcOffset(this.tmznOfs).startOf('day'), moment().utcOffset(this.tmznOfs)]; // 오늘
                this.dateRange[this.translate.instant('MK.00901')] = [moment().utcOffset(this.tmznOfs).subtract(1, 'days').startOf('day'), moment().utcOffset(this.tmznOfs).subtract(1, 'days').endOf('day')]; // 어제
                this.dateRange[this.translate.instant('MK.01370')] = [moment().utcOffset(this.tmznOfs).subtract(6, 'days').startOf('day'), moment().utcOffset(this.tmznOfs)];   //최근 일주일
                this.dateRange[this.translate.instant('MK.01473')] = [moment().utcOffset(this.tmznOfs).subtract(1, 'month').startOf('day'), moment().utcOffset(this.tmznOfs)];   //최근 한달
                this.dateRange[this.translate.instant('MK.00904')] = [moment().utcOffset(this.tmznOfs).startOf('week'), moment().utcOffset(this.tmznOfs).endOf('week')];
                this.dateRange[this.translate.instant('MK.00903')] = [moment().utcOffset(this.tmznOfs).startOf('month'), moment().utcOffset(this.tmznOfs).endOf('month')]; // this month
                this.dateRange[this.translate.instant('MK.00005')] = [moment().utcOffset(this.tmznOfs).subtract(1, 'week').startOf('week'), moment().utcOffset(this.tmznOfs).subtract(1, 'week').endOf('week')];
                this.dateRange[this.translate.instant('MK.00006')] = [moment().utcOffset(this.tmznOfs).subtract(1, 'month').startOf('month'), moment().utcOffset(this.tmznOfs).subtract(1, 'month').endOf('month')]; // last month
                break;
        }
        const ranges = _.values(this.dateRange);

        if (times.label === undefined ) {
            switch (type) {
                case 'free':
                    times.label = DateRangeForFreeTier.RECENT7DAY;
                    break;
                case 'freeReport':
                    times.label = DateRangeForFreeTierReport.RECENT7DAY;
                    break;
                case 'standardReport':
                    times.label = DateRangeForReport.RECENT7DAY;
                    break;
                case 'standard':
                default:
                    times.label = DateRange.RECENT7DAY;
                    break;
            }

        } else if ( (type === 'free' && times.label === DateRangeForFreeTier.CUSTOM)
                    || (type === 'freeReport' && times.label === DateRangeForFreeTierReport.CUSTOM)
                    || (type === 'standardReport' && times.label === DateRangeForReport.CUSTOM)
                    || (type === 'standard' && times.label === DateRange.CUSTOM)) {
            ranges[times.label] = [moment(times.fromDate), moment(times.toDate)];
        }

        const rangeObj = ranges[times.label];

        this.options = {
            autoUpdateInput: true,
            ranges: this.dateRange,
            startDate: rangeObj[0].format('YYYY-MM-DD'),
            endDate: rangeObj[1].format('YYYY-MM-DD'),
            locale: {
                format: 'YYYY-MM-DD',
                cancelLabel: this.translate.instant('MK.00048'),
                customRangeLabel: this.translate.instant('MK.00905'),
                applyLabel: this.translate.instant('MK.00049'),
                daysOfWeek: [
                    this.translate.instant('MK.00868'),
                    this.translate.instant('MK.00869'),
                    this.translate.instant('MK.00870'),
                    this.translate.instant('MK.00871'),
                    this.translate.instant('MK.00872'),
                    this.translate.instant('MK.00873'),
                    this.translate.instant('MK.00874')
                ],
                monthNames: [
                    this.translate.instant('MK.00875'),
                    this.translate.instant('MK.00876'),
                    this.translate.instant('MK.00877'),
                    this.translate.instant('MK.00878'),
                    this.translate.instant('MK.00879'),
                    this.translate.instant('MK.00880'),
                    this.translate.instant('MK.00881'),
                    this.translate.instant('MK.00882'),
                    this.translate.instant('MK.00883'),
                    this.translate.instant('MK.00884'),
                    this.translate.instant('MK.00885'),
                    this.translate.instant('MK.00886')
                ]
            },
            alwaysShowCalendars: false,
            minDate: this.currLcnsTypeCd === 'LCNS000' ? moment().utcOffset(this.tmznOfs).subtract(6, 'days') : moment('2016-01-01'),
            maxDate: moment().utcOffset(this.tmznOfs)
        };
    }

    public getType() {
        let type = 'standard';

        if (this.currLcnsTypeCd === 'LCNS000') {
            if (this.isReport !== undefined && !this.isReport) {
                type = 'free';
            } else {
                type = 'freeReport';
            }
        } else {
            if (this.isReport !== undefined && !this.isReport) {
                type = 'standard';
            } else {
                type = 'standardReport';
            }
        }
        return type;
    }


}



// WEBPACK FOOTER //
// ./src/app/components/daterangepicker/daterangepicker.component.ts